import React, { useRef, useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const TruncatedPara = ({
  text = '',
  profession = '',
  name = '',
  maxLines = 2
}) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const paragraphRef = useRef(null);
  const [open, setOpen] = useState(false);

  // Check if the paragraph is overflowing
  useEffect(() => {
    if (paragraphRef.current) {
      const { scrollHeight, clientHeight } = paragraphRef.current;
      setIsOverflowing(scrollHeight > clientHeight);
    }
  }, [text]);

  const openDialog = () => {
    setIsExpanded(false);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div style={{ margin: '0 auto' }}>
        <p
          ref={paragraphRef}
          style={{
            display: isExpanded ? 'block' : '-webkit-box',
            WebkitLineClamp: isExpanded ? 'unset' : maxLines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {text}
        </p>
        {isOverflowing ? (
          <a
            style={{
              textDecoration: 'underline',
              color: 'blue',
              cursor: 'pointer'
            }}
            onClick={() => {
              openDialog();
            }}
          >
            {isExpanded ? 'Show Less' : 'Read More'}
          </a>
        ) : (
          <a
            style={{
              textDecoration: 'underline',
              color: 'blue',
              cursor: 'pointer',
              visibility: 'hidden'
            }}
            onClick={() => {}}
          >
            Read more
          </a>
        )}
      </div>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={{ marginRight: '5px', p: 2, width: '90%' }}
          id="customized-dialog-title"
        >
          {name}
          {profession && `(${profession})`}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: -4,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>{text}</DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default TruncatedPara;
